import { Alert, Button, Grid, Box, Typography as MuiTypography } from "@mui/material"
import { MainLoggedInLayout } from "../../components/layouts/main.loggedIn.layout"
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import { useQuery } from '@tanstack/react-query'
import { getAccounts } from "../../controllers/accounts/accounts";
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { UserContext } from "../../context/UserContext";
import { Loading } from "../../util/util"
import { useProfileComplete } from "../../hooks/useProfileComplete";

export const AccountList = () => {
    const [offset, setOffset] = useState(0)
    const [local, setLocal] = useState(true)
    const [errImg, setErrImg] = useState([])
    const { userDetails } = useContext(UserContext)
    let token = userDetails?.token ?? ''
    let navigate = useNavigate()
    const myRef = useRef(null)
    
    // Check profile completion and redirect if needed
    useProfileComplete(userDetails)
    const { data:accounts, refetch } = useQuery({ queryKey: ['getAllAccounts'], queryFn: () => getAccounts(offset, local, token) })
    useEffect(() => {
        refetch()
        myRef.current.scrollIntoView()
    })

    if(accounts?.length < 1){
        return (
            <MainLoggedInLayout>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
                    <Loading />
                </Box>
            </MainLoggedInLayout>
        )
    }

    return (
        <MainLoggedInLayout>
            <Box sx={{ maxWidth: 900, mx: 'auto', mt: { xs: 1.5, sm: 3 }, mb: 2, px: { xs: 1, sm: 0 } }}>
                <MuiTypography variant="h4" sx={{ mb: 2, fontWeight: 600, textAlign: 'center', letterSpacing: 1, fontSize: { xs: '1.5rem', sm: '2.125rem' } }}>
                    Member Directory
                </MuiTypography>
                <Box ref={myRef} sx={{ mb: 3 }}>
                    <Alert severity="success" sx={{ p: { xs: 1, sm: 2 } }}>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            alignItems: { xs: 'stretch', sm: 'center' },
                            width: '100%'
                        }}>
                            <MuiTypography variant="body1" sx={{ ml: { xs: 0, sm: 1 }, flex: 1, mb: { xs: 1, sm: 0 }, textAlign: { xs: 'center', sm: 'left' } }}>
                                {local
                                    ? 'View MakeGayFriends members only'
                                    : 'All members from all servers on Mastodon following MakeGayFriends'}
                            </MuiTypography>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    setLocal(local ? false : true)
                                    setOffset(0)
                                }}
                                sx={{ minWidth: 100, ml: { xs: 0, sm: 2 }, width: { xs: '100%', sm: 'auto' } }}
                            >
                                Switch
                            </Button>
                        </Box>
                    </Alert>
                </Box>
            </Box>
            <Box sx={{ maxWidth: 1200, mx: 'auto', px: { xs: 0, sm: 1 } }}>
                <Grid container spacing={{ xs: 2, sm: 3 }} justifyContent="center" alignItems="stretch">
                    {accounts?.length < 1 && (
                        <MuiTypography sx={{ width: '100%', textAlign: 'center', mt: 4 }}>No results, resetting...</MuiTypography>
                    )}
                    {accounts?.length > 0 && accounts?.map((account, index) => (
                        !account.avatar.includes("missing") && !errImg.includes(account.id) &&
                        <Grid item xs={4} sm={3} md={2} lg={2} key={index} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: { xs: 1.2, sm: 2 } }}>
                            <Box
                                onClick={() => navigate("/profile/" + account.id)}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    width: '100%',
                                    transition: 'transform 0.15s, box-shadow 0.15s',
                                    '&:hover': {
                                        transform: 'scale(1.06)',
                                        boxShadow: 4,
                                    },
                                    p: 0,
                                }}
                            >
                                <Box
                                    component="img"
                                    src={account.avatar}
                                    alt={account.username}
                                    onError={() => setErrImg(errImg => [...errImg, account.id])}
                                    sx={{
                                        width: { xs: 54, sm: 70, md: 80 },
                                        height: { xs: 54, sm: 70, md: 80 },
                                        borderRadius: '50%',
                                        objectFit: 'cover',
                                        background: '#eee',
                                        border: '2px solid #fff',
                                        boxShadow: 2,
                                        mb: 0.7,
                                        transition: 'box-shadow 0.2s',
                                    }}
                                />
                                <MuiTypography
                                    variant="subtitle2"
                                    noWrap
                                    sx={{
                                        maxWidth: { xs: 60, sm: 80, md: 100 },
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        textAlign: 'center',
                                        fontWeight: 500,
                                        fontSize: { xs: '0.88rem', sm: '0.98rem' },
                                        color: 'text.primary',
                                    }}
                                >
                                    @{account.acct}
                                </MuiTypography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Box>
            <Box sx={{ maxWidth: 900, mx: 'auto', mt: 3, mb: 2, px: { xs: 1, sm: 0 } }}>
                <Card sx={{ boxShadow: 0 }}>
                    <CardContent sx={{ textAlign: 'center', p: { xs: 1, sm: 2 } }}>
                        {accounts && accounts.length > 39 &&
                            <Button
                                onClick={() => {
                                    setOffset(offset + 40)
                                }}
                                variant="contained"
                                sx={{ m: 1, minWidth: 100 }}
                            >
                                Next
                            </Button>}
                        {accounts && offset > 0 &&
                            <Button
                                onClick={() => {
                                    setOffset(offset - 40)
                                }}
                                variant="contained"
                                sx={{ m: 1, minWidth: 100 }}
                            >
                                Previous
                            </Button>}
                    </CardContent>
                </Card>
            </Box>
        </MainLoggedInLayout>
    )
}